"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateAppsFlyerAttributionEventQuerySchema = void 0;
const typebox_1 = require("@sinclair/typebox");
// We are very lenient on these schemas, but perhaps we should add more validation when we have more test data
exports.CreateAppsFlyerAttributionEventQuerySchema = typebox_1.Type.Object({
    campaignId: typebox_1.Type.Integer(),
    secretKey: typebox_1.Type.String(),
    revenue: typebox_1.Type.Optional(typebox_1.Type.String()),
    currency: typebox_1.Type.Optional(typebox_1.Type.String()),
    eventTimeEpoch: typebox_1.Type.Optional(typebox_1.Type.String()),
    eventToken: typebox_1.Type.Optional(typebox_1.Type.String()),
    eventName: typebox_1.Type.Optional(typebox_1.Type.String()),
    isRetargeting: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.Integer(), typebox_1.Type.Boolean()])),
    installTimeEpoch: typebox_1.Type.Optional(typebox_1.Type.String()),
    clickTimeEpoch: typebox_1.Type.Optional(typebox_1.Type.String()),
    keyword: typebox_1.Type.Optional(typebox_1.Type.String()),
    adGroupId: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    deviceId: typebox_1.Type.Optional(typebox_1.Type.String()),
    idfa: typebox_1.Type.Optional(typebox_1.Type.String()),
});
